import { REPORTS } from '@/mocks/data';

const labelColor = ['bg-primary-600 text-background-50', 'bg-accent-500 text-foreground-950', 'bg-secondary-600 text-background-50'];

export default function Reports() {
  return (
    <section id="reports" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              不止于快讯
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-[34px]">深度特辑</h2>
          </div>
          <p className="max-w-md text-xs leading-relaxed text-foreground-500 md:text-sm">
            对热点背后的趋势做更完整的拆解,帮你把"看热闹"升级为"看门道"。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {REPORTS.map((rp, i) => (
            <article
              key={rp.title}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={rp.image}
                  alt={`${rp.title}深度内容专题配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 rounded-md px-2.5 py-1 text-xs font-bold ${labelColor[i % 3]}`}>
                  {rp.label}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {rp.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{rp.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-book-open-line"></i>
                    {rp.time}
                  </span>
                  <span className="flex items-center gap-1 text-primary-700">
                    {rp.read} 人已读
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}